import React, { type FunctionComponent } from 'react'
import { FormattedMessage } from 'react-intl'
import HeroBannersListFilters from 'domains/merchandising/components/hero-banners-list/components/filters/HeroBannersListFilters'
import { useHeroBannerList } from 'domains/merchandising/utils/useQueryHeroBannerList.hooks'
import ContentContainer from 'legacy/components/ContentContainer'
import AppHeader from 'legacy/components/AppHeader'
import Table from 'legacy/components/Table/Table'

export const HeroBannersList: FunctionComponent = () => {
  const { searchHeroBanners, apiLoading, apiError, columns, banners } = useHeroBannerList()

  return (
    <div>
      <AppHeader title={<FormattedMessage id="merchandising.hero-banners.title" />} />
      <HeroBannersListFilters searchHeroBanners={searchHeroBanners} />
      <ContentContainer style={{ padding: 0 }}>
        <Table
          columns={columns}
          isLoading={apiLoading}
          isError={!!apiError}
          data={banners || []}
          getTrProps={() => ({
            style: { minHeight: '60px', padding: '0 20px' },
          })}
          noDataText="No data"
        />
      </ContentContainer>
    </div>
  )
}
